
import { defineComponent } from 'vue';

export default defineComponent({
  created() {
    const { params, query } = this.$route;
    const { path } = params;
    this.$router.replace({ path: `/${path}`, query }).catch((err: Error) => {
      console.warn(err);
    });

    // const { params, query } = this.$route;
    // const newQuery = {} as HistoryState;
    // const r = Math.random();
    // if (query) {
    //   const entries = Object.entries(query);
    //   for (const [key, value] of entries) {
    //     if (key !== '_r') {
    //       newQuery[key] = value;
    //     }
    //   }
    //   // eslint-disable-next-line no-underscore-dangle
    //   newQuery._r = r;
    // }
    // const { path } = params;
    // console.log(path);
    // this.$router.replace({ path: `/${path}`, newQuery } as RouteLocationRaw);
  },
  // eslint-disable-next-line vue/require-render-return
  render() {
    // Avoid warning for missing template
  },
});
